<button (click)="goToRouteProvidedOrOneStepBack()" class="btn btn-light p-0 font-weight-normal" [tabIndex]="tabindex" [ngClass]="classes">
  <i class="fa mr-2 text-size-normal" [ngClass]="icon"></i>{{buttonText}}
</button>
